.bt{right:0px;}